export enum PushToSftpModalModes {
  PUSH = "push",
  TRACK = "track",
  TEXT_NOTE = "textNote",
  DOWNLOAD = "download",
  PUSHED_DOWNLOAD = "pushedDownload",
}
